module.exports = __webpack_public_path__ + "static/media/Lecce.8eb452ba.png";